<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 家族からの連絡事項の使用可否
        span.validation-label 必須
      .right-side
        slot(name="question")

    .register-value.reservation-input-type-radios
      label.register-radio-label
        input#type-0.register-radio-form(
          v-model="_value"
          :name="name"
          type="radio"
          :value="false"
          v-validate="{ required: true }"
          data-vv-as="自動承諾")
        span.register-radio-text 使用しない
      label.register-radio-label
        input#type-1.register-radio-form(v-model="_value" :name="name" type="radio" :value="true")
        span.register-radio-text 使用する

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

@Component
export default class FormInputUseText extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Boolean })
  value!: boolean;

  @Prop({ default: "use-text" })
  name!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): boolean {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.reservation-input-type-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}
</style>
